let msgServer;
/*import {DoccliService} from '../../../../providers/DoccliService.js';
const doccliService = new DoccliService();*/
import QrcodeVue from 'qrcode.vue'
import {AppService} from '../../../../providers/AppService.js';
const appService = new AppService();
export default {
    name: "QrcodeSign",
     data () {
    return {
      tabs: null,
      text: 'chargement en cours...',
      webFlow: "",
      webFlowSign: 200,
      showWait: true,
      message:'',

    }
  },components: {
    QrcodeVue,
  },
  mounted: function () {
   
    this.getQrcodeSign();
  },
  beforeDestroy() {
    // Make sure to close the connection with the events server
    // when the component is destroyed, or we'll have ghost connections!
    if(msgServer)
      msgServer.close();
  },

  methods: {
    getQrcodeSign: function(){
       //récuperation dans la session
       var sessionSouscription = this.$globalService.getSessionSouscription();
       if(sessionSouscription != null && sessionSouscription.webflow_signature_url){         
         this.webFlowSign = sessionSouscription.webflow_signature_url;
         
        this.$dialog.warning({
          text: "Scanner le qrcode avec votre tablette afin de signer les documents",
          title: 'Signature électronique',
          persistent: true
        });

            //***************************** PARTIE SSE */
            this.$sse(appService.getBaseUrl()+'/sse/sse_sign.php?idSouscription='+sessionSouscription.souscriptionId, { format: 'json' })
              .then(sse => {
                // Store SSE object at a higher scope
                msgServer = sse;
        
                //si statut progress ne fais rien 
                sse.subscribe('PROGRESS', () => {
                  this.message = 'TRAITEMENT EN COURS !!!';
                  

                });//si statut SIGNATURE_WEBFLOW_ENDED redirection vers RecapSignAutprev pour tiers payeur ok RecapSignOk
                sse.subscribe('SIGNATURE_WEBFLOW_ENDED', () => {
                  this.message = "ANALYSE EN COURS DES DOCUMENTS !!!";
                  msgServer.close();
                  this.showWait = false;
                  if(this.$globalService.getSessionSouscription().typeSignProgress == 'webflowsign' && sessionSouscription.existTiersPayeur == 1)
                    this.$router.push({name: 'RecapSignAutprev'});
                  else{
                    if(this.$root.token)
                      this.$router.push({name: 'RecapSignOkForToken'});
                    else
                      this.$router.push({name: 'RecapSignOk'});
                  }
                    
                });

                //si statut SIGNATURE_WEBFLOW_ENDED ne fais rien 
                sse.subscribe('SIGNATURE_WEBFLOW_DECLINED', () => {
                  this.message = "ANALYSE EN COURS DES DOCUMENTS !!!";
                  msgServer.close();
                  this.showWait = false;
                  this.$router.push({name: 'RecapSignError'});
                    
                });

                //si statut SIGNATURE_WEBFLOW_ENDED ne fais rien 
                sse.subscribe('SIGNATURE_WEBFLOW_BLOCKED', () => {
                  this.message = "ANALYSE EN COURS DES DOCUMENTS !!!";
                  msgServer.close();
                  this.showWait = false;
                  this.$router.push({name: 'RecapSignError'});
                    
                });



                sse.subscribe('SIGNATURE_WEBFLOW_ERROR', () => {
                  this.showWait = false;
                  this.$dialog.error({
                    text: this.$root.errorMessage,
                    title: 'Erreur',
                    persistent: false,
                    actions: {
                      false: 'Fermer'
                    }
                  })
                  msgServer.close();
                });

                sse.subscribe('ERROR', () => {
                  this.showWait = false;
                  this.$dialog.error({
                    text: this.$root.errorMessage,
                    title: 'Erreur',
                    persistent: false,
                    actions: {
                      false: 'Fermer'
                    }
                  })
                  msgServer.close();
                });
            })
          .catch(err => {
            
              console.error('Failed to connect to server', err);
              this.$dialog.error({
                text: this.$root.errorMessage,
                title: 'Erreur',
                persistent: false,
                actions: {
                  false: 'Fermer'
                }
              })
          });

        //******************* FIN SSE */
       }else{
        this.$dialog.error({
          text: this.$root.errorMessage,
          title: 'Erreur',
          persistent: false,
          actions: {
            false: 'Fermer'
          }
        })
       }
      
    }
  }
}